// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NotificationItem__wrapper__3N2Bt","img":"NotificationItem__img__1eIKm","text":"NotificationItem__text__m_SNX","iconWrapper":"NotificationItem__iconWrapper__38A2u"};